// import { apyToApr } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

// const SUSDX_URL = 'https://app.usdx.money/v1/base/apyInfo'
const susdx = 'SUSDX'

/** SUSDX is discontinued */
export const susdxFetcher: YieldFetcher = {
  label: 'SUSDX',
  fetch: async () => {
    // const res = await fetch(SUSDX_URL).then((r) => r.json())
    return {
      [susdx]: 0,
      // apyToApr(res.result.susdxApy) * 100
    }
  },
}
